import {CheckOperations, ComparisonOperations} from "./Operations";
import InternalSummaryPanel from "../InternalSummaryPanel";
import {useAppContext} from "../../Context/ProjectContextV2";
import CompareSummaryPanel from "../CompareSummaryPanel";
import {useEffect} from "react";
import {GetMessageCodeText} from "../Output/MessageCodes";
import MessageSelectedCheck from "./MessageSelectedCheck";
import EmptyLine from "../EmptyLine";
import MessageSelectedComparison from "./MessageSelectedComparison";

export default function MessageTab({type, operation}) {
    const {getSelectedHistory, getOperationItemConfig, getSelectedRS, selectedErrorId} = useAppContext()

    const MessageComponent = ({operation}) => {
        let item = getOperationItemConfig()

        useEffect(() => {

        }, [operation])

        if(item) {
            const {Component} = item
            return (
                <div>
                    <EmptyLine />
                    <div style={{marginLeft: 8}}>
                        {type === 'Check' && <MessageSelectedCheck dataSource={[getSelectedHistory()]} />}
                        {type === 'Comparison' && <MessageSelectedComparison dataSource={[getSelectedHistory()]} />}
                    </div>
                    <Component
                        data={operation?.data}
                        message_key={operation.key}
                    />
                </div>
            )
        }

        if(!type)
            return (<></>)

        if(type === 'Check')
            return (
                <div style={{marginLeft: 8}}>
                    <EmptyLine />
                    <MessageSelectedCheck dataSource={[getSelectedHistory()]} />
                    <InternalSummaryPanel summary={getSelectedHistory()?.summary?.base} calculation_tolerances={getSelectedHistory()?.calculation_tolerances} report={false} />
                </div>
            )

        return (
            <div style={{marginLeft: 8}}>
                <EmptyLine />
                <MessageSelectedComparison dataSource={[getSelectedHistory()]} />
                <CompareSummaryPanel
                    summary={getSelectedHistory()?.summary}
                    report={false}
                    plan={{
                        base: getSelectedHistory()?.selection?.base?.plan,
                        compare: getSelectedHistory()?.selection?.compare?.plan,
                    }}
                    wsel={getSelectedHistory()?.wsel}
                    filter={getSelectedHistory()?.page?.filter} preparing={false}
                />
            </div>
        )
    }

    return (
        <div style={{backgroundColor: 'white'}}>
            <MessageComponent operation={operation}/>
        </div>
    )
}